export default __webpack_public_path__ + "static/media/check1.d52ff20a.jpg";